import { useEffect } from 'react';

import { useChatPageState } from '@/shared/contexts/ChatPageContext';

/**
 * Convenience hook for page components to publish their state to the
 * chat widget context. Automatically clears context on unmount.
 *
 * @param {Object} contextData - Page state to publish (e.g., { page, spotlight, ... })
 * @param {Array} deps - Dependency array controlling when context updates
 */
export default function useChatPageEffect(contextData, deps) {
    const { setPageState } = useChatPageState();

    useEffect(() => {
        setPageState(contextData);
        return () => setPageState({});
    }, deps); // eslint-disable-line
}
